import { useMemo, useQuery } from 'sb-hooks'

import discountCode from './discountCode.graphql'


type useVindiciaCouponQueryProps = {
  coupon: string
  gender: Gender
  plan: string
  skip?: boolean
}

type ReturnType = {
  product: GiftOfferModal.ProductType
  isFetching: boolean
  fetch: () => void
}


const useVindiciaCouponQuery = (props: useVindiciaCouponQueryProps): ReturnType => {
  const { coupon, skip, gender, plan } = props

  const queryOptions = useMemo(() => ({
    name: 'discountCode',
    variables: {
      code: coupon,
      gender,
      plan,
    },
    skip,
    modifyResult: ({ discountCode }) => {
      const { code } = discountCode

      if (code && code.freeProduct) {
        const { freeProduct: { ratings, ...productData } } = code

        return {
          ...productData,
          rating: ratings.avgRate,
        }
      }

      return null
    },
  }), [ coupon, gender, plan, skip ])

  const { data: product, isFetching, fetch } = useQuery<ReturnType['product']>(discountCode, queryOptions)

  return {
    product,
    isFetching,
    fetch,
  }
}


export default useVindiciaCouponQuery
